import { Skeleton } from '@hqo/ui-atoms';

/**
 * Placeholder body for the confirmation modal while the visit is still being fetched.
 *
 * It renders INSIDE the confirmation modal's own frame rather than in a separate loading modal, so the
 * frame (swipe modal / activity-pane wrapper) mounts once and its swipe-up animation plays once. The body
 * then swaps skeleton -> visit in place, instead of one modal being torn down and a fresh one animated in
 * over the top — the "double swipe" stutter a deeplink used to show while the fetch settled.
 *
 * The shape mirrors the loaded body (avatar + heading, then a bordered details card) so the arrival is a
 * fill rather than a jump.
 */
export const ConfirmationModalSkeleton = (): JSX.Element => (
  <div className="flex flex-col items-center w-full pt-6" data-testid="visit-details-loading">
    <div className="flex flex-col items-center gap-3 mb-8">
      <Skeleton className="w-12 h-12 rounded-full" />
      <Skeleton className="h-7 w-48" />
    </div>
    <div className="w-full border border-gray-200 rounded-lg p-6 flex flex-col gap-6">
      <Skeleton className="h-6 w-32" />
      <div className="flex flex-col gap-4">
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-5 w-28" />
        <Skeleton className="h-5 w-44" />
        <Skeleton className="h-5 w-36" />
      </div>
      <Skeleton className="h-10 w-full" />
    </div>
  </div>
);
